import { render, staticRenderFns } from "./NiceClassTypeList.vue?vue&type=template&id=3b7fdb4e&"
import script from "./NiceClassTypeList.vue?vue&type=script&lang=js&"
export * from "./NiceClassTypeList.vue?vue&type=script&lang=js&"
import style0 from "./NiceClassTypeList.vue?vue&type=style&index=0&id=3b7fdb4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports